// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { COLOR, POSITION } from './field-item.model';

@Injectable({
  providedIn: 'root'
})
export class FieldItemService {

   constructor () {}

   public getColor (attribute?: string, defaultColor?: COLOR): string {
      if (!attribute) return defaultColor ? defaultColor : COLOR.TEXT;
      const result = Object.keys(COLOR)
                     .filter(key => attribute.toUpperCase() == key)
                     .map(key => key == 'DEFAULT' ? defaultColor ? defaultColor : COLOR.TEXT : COLOR[key as keyof typeof COLOR]);
      
      return result[0] || (defaultColor ? defaultColor : COLOR.TEXT);
   }

   public getPos (attribute?: string, defaultPos?: POSITION): string {
      if (!attribute) return defaultPos ? defaultPos : POSITION.LEFT;
      const result = Object.keys(POSITION)
                     .filter(key => attribute.toUpperCase() == key )
                     .map(key => key == 'DEFAULT' ? defaultPos ? defaultPos : POSITION.LEFT : POSITION[key as keyof typeof POSITION]);
      
      return result[0] || (defaultPos ? defaultPos : POSITION.LEFT);
   }
}